// extracted by mini-css-extract-plugin
export default {"container":"Integration_container__Q8bD7","body":"Integration_body__IYov-"};